import { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { ImportProjectTextField } from './ImportProjectTextField';
import { FolderImportFormValues } from './types';

export const FolderImportProjectStep: React.FC<{ disabled?: boolean; }> = () => {
  const { formatMessage } = useIntl();

  const { control, setValue } = useFormContext<FolderImportFormValues>();

  const projectToImportFromId = useWatch({ control, name: 'projectToImportFromId' });

  useEffect(() => {
    setValue('folderIds', []);
  }, [setValue, projectToImportFromId]);

  return (
    <Controller
      control={control}
      name='projectToImportFromId'
      rules={{ required: formatMessage({ id: 'A project must be selected' }) }}
      render={({ field, fieldState: { error } }) => (
        <ImportProjectTextField
          value={field.value}
          error={error?.message}
          onChange={field.onChange}
        />
      )}
    />
  );
};